import React from "react";
import { IntlProvider } from "react-intl";
import { CookiesProvider } from "react-cookie";
import { flatten } from "flat";

import { DataProvider } from "./data-context";

import fr from "@ace-hotel/locales/fr.json";
import en from "@ace-hotel/locales/en.json";

const messages = {
  fr: fr,
  en: en,
};

const WrapPageElement = ({ element, props }) => {
  const locale = props.pageContext.locale;

  return (
    <IntlProvider
      locale={locale}
      defaultLocale="fr"
      messages={locale && flatten(messages[locale])}
    >
      <CookiesProvider>
        <DataProvider value={props}>{element}</DataProvider>
      </CookiesProvider>
    </IntlProvider>
  );
};

export default WrapPageElement;
